import React, { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import "./OurServices.scss";

import OurServicesMasterCard from "./OurServicesMasterCard";

// thumbnail imports
import brandStrategyImg   from "resources/images/services-thumbs/brand_strategy.png";
import leadGenerationImg  from "resources/images/services-thumbs/marketing_lead_generation.png";
import graphicCopyImg     from "resources/images/services-thumbs/graphic_design_copywriting.png";
import webDevImg          from "resources/images/services-thumbs/web_app_system_development.png";
import storeMgmtImg       from "resources/images/services-thumbs/online_store_management.png";
import specialProjectsImg from "resources/images/services-thumbs/special_projects.png";

export default function OurServices() {
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerMode: true,
          centerPadding: "0px"
        }
      }
    ]
  };

  const services = [
    {
      img: brandStrategyImg,
      title: "Brand Strategy & Identity",
      copy: "Clarify your brand from the ground up. We help you shape your message, visuals, and positioning so your business stands out, connects, and grows. Perfect if you’re starting out or stuck in the wrong look.",
      url: "/contact-us",
      label: "Start project",
      serviceUrl: "/brand-strategy-and-identity"
    },
    {
      img: leadGenerationImg,
      title: "Marketing & Lead Generation",
      copy: "No more guesswork. We create strategies, funnels, and campaigns that attract your ideal customers and turn them into loyal buyers. Great for businesses ready to grow but missing a clear path.",
      url: "/contact-us",
      label: "Start project",
      serviceUrl: "/marketing-and-lead-generation"
    },
    {
      img: graphicCopyImg,
      title: "Graphic Design & Copywriting",
      copy: "Need consistent content that looks sharp and sounds right? From social graphics to campaign messaging, pitch decks to sales materials, we craft assets that bring your brand to life and move people to action.",
      url: "/contact-us",
      label: "Start project",
      serviceUrl: "/graphic-design-and-copywriting"
    },
    {
      img: webDevImg,
      title: "Web, App & System Development",
      copy: "We design and build high-performing websites, apps, and backend systems that grow with your business. If your current setup feels clunky or limited, we’ll create a smarter experience built to scale.",
      url: "/contact-us",
      label: "Start project",
      serviceUrl: "/web-app-and-system-development"
    },
    {
      img: storeMgmtImg,
      title: "Online Store Management",
      copy: "We keep your e-commerce moving smoothly. From campaign planning and product uploads to seasonal updates and merchandising, we handle the backend so you can focus on the bigger picture.",
      url: "/contact-us",
      label: "Start project",
      serviceUrl: "/online-store-management"
    },
    {
      img: specialProjectsImg,
      title: "Special Projects",
      copy: "Got a creative idea that doesn’t fit the usual mold? We take on custom requests like product concepts, packaging, visual prototypes, and unique brand executions that set you apart.",
      url: "/contact-us",
      label: "Start project",
      serviceUrl: "/special-projects"
    }
  ];

  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { rootMargin: "0px 0px -20% 0px" }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className={`our-services${inView ? " in-view" : ""}`}>
      <div className="component">
        <h2 className="title-generic">
          Our <span>Services</span>
        </h2>

        <Slider {...settings} className="services-slider">
          {services.map(({ img, title, copy, url, label, serviceUrl }, idx) => (
            <OurServicesMasterCard
              key={idx}
              img={img}
              title={title}
              copy={copy}
              url={url}
              label={label}
              serviceUrl={serviceUrl}
            />
          ))}
        </Slider>
      </div>
    </section>
  );
}
